import { Dialog, BUTTON_VARIANTS } from 'cdk-radial';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../theme/useTheme';
import * as Styles from '../core/styles-card';
import { useMobileAppLaunchStore } from './useMobileAppLaunchStore';

export default function GetMobileAppDialog() {
  const { t } = useTranslation();
  const { darkMode } = useTheme();
  const setShowDialog = useMobileAppLaunchStore((state: any) => state.setShowDialog);
  const showDialog = useMobileAppLaunchStore((state: any) => state.showDialog);
  const appName = useMobileAppLaunchStore((state: any) => state.appName);
  const appIcon = useMobileAppLaunchStore((state: any) => state.appIcon);
  const appIconColor = useMobileAppLaunchStore((state: any) => state.appIconColor);
  const appDescription = useMobileAppLaunchStore((state: any) => state.appDescription);
  const appDownloadUrl = useMobileAppLaunchStore((state: any) => state.appDownloadUrl);

  const onCancel = () => setShowDialog(false);

  const getApp = () => {
    setShowDialog(false);
    if (!appDownloadUrl) return;
    window.location.href = appDownloadUrl;
  };

  return (
    <Dialog
      id="get-mobile-app-dialog"
      dataTestId="getapp-dialog-getapp-alert"
      isOpen={showDialog}
      onClose={onCancel}
      title={t('getMobileAppDialog.getAppTitle')}
      buttonsProps={[
        {
          id: 'getapp-dialog-cancel',
          dataTestId: 'getapp-dialog-cancel',
          text: t('getMobileAppDialog.cancelBtn'),
          variant: BUTTON_VARIANTS.TEXT,
          onClick: onCancel,
          style: { color: darkMode ? 'white' : 'black' },
        },
        {
          id: 'getapp-dialog-getapp',
          dataTestId: 'getapp-dialog-getapp',
          text: t('getMobileAppDialog.getAppButton') + appName,
          variant: BUTTON_VARIANTS.PRIMARY,
          onClick: getApp,
          style: {
            color: darkMode ? 'black' : 'white',
            backgroundColor: darkMode ? 'white' : 'black',
          },
        },
      ]}
    >
      <Styles.CardHeader>
        <Styles.ProductIcon iconColor={appIconColor} data-testid="app-icon">
          {appIcon || ''}
        </Styles.ProductIcon>
        <Styles.CardTitle>{appName}</Styles.CardTitle>
      </Styles.CardHeader>
      <div style={{ fontSize: '16px', fontWeight: 400, lineHeight: '24px', paddingTop: '10px' }}>
        {appDescription}
      </div>
    </Dialog>
  );
}
